"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatus = exports.WalletPath = exports.FaceVersionLocalKey = exports.FaceShare1LocalKey = exports.FaceUserLocalKey = exports.FaceSessionLocalKey = void 0;
exports.FaceSessionLocalKey = 'Face-Session';
exports.FaceUserLocalKey = 'Face-User';
exports.FaceShare1LocalKey = 'Face-Share1';
exports.FaceVersionLocalKey = 'Face-Version';
exports.WalletPath = `m/44'/60'/1'/0/0`;
var UserStatus;
(function (UserStatus) {
    UserStatus["isWalletCreated"] = "isWalletCreated";
    UserStatus["isNewUser"] = "isNewUser";
    UserStatus["isRegisteredPinCode"] = "isRegisteredPinCode";
    UserStatus["isAdmin"] = "isAdmin";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
//# sourceMappingURL=user.js.map